import { useEffect, useRef, useState } from "react";
import { Columns3 } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Selettore colonne personalizzate opzionali della tabella Rubrica (scelta salvata per utente nel browser). */
export function CustomColumnsPicker({ defs, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);
  const active = defs.filter((d) => d.active);
  if (!active.length) return null;
  const toggle = (k) => onChange(selected.includes(k) ? selected.filter((x) => x !== k) : [...selected, k]);
  return (
    <div className="relative hidden lg:block" ref={ref}>
      <Button type="button" variant="outline" onClick={() => setOpen((o) => !o)} data-testid="cf-columns-button"
              className={`bg-[#1E293B] border-[#1F2937] text-slate-200 hover:bg-[#334155] ${selected.length ? "border-[#10B981]/50" : ""}`}>
        <Columns3 className="h-4 w-4 mr-2" /> Colonne{selected.length ? ` (${selected.length})` : ""}
      </Button>
      {open && (
        <div className="absolute right-0 z-30 mt-1 w-64 max-h-72 overflow-y-auto rounded-xl border border-[#1F2937] bg-[#111827] p-2 shadow-xl" data-testid="cf-columns-menu">
          <p className="text-[11px] text-slate-500 px-1 pb-1">Campi personalizzati da mostrare in tabella</p>
          {active.map((d) => (
            <label key={d.field_key} className="flex items-center gap-2 px-1 py-1 text-xs text-slate-200 cursor-pointer hover:bg-[#1F2937]/60 rounded">
              <input type="checkbox" checked={selected.includes(d.field_key)} onChange={() => toggle(d.field_key)} data-testid={`cf-column-toggle-${d.field_key}`} className="accent-[#10B981]" />
              <span className="truncate">{d.label}</span><span className="ml-auto font-mono text-[10px] text-slate-500">{d.field_key}</span>
            </label>
          ))}
          {selected.length > 0 && <button type="button" onClick={() => onChange([])} data-testid="cf-columns-clear" className="mt-1 text-[11px] text-slate-400 hover:text-slate-200 underline px-1">Nascondi tutte</button>}
        </div>
      )}
    </div>
  );
}
